<template>
<div class="drawerWrap  alarmDrawer">
   <div class="drawerBody">
      <div class="noice" v-if="sendresult1.length>0">
          <div v-for="(list,index) in sendresult1" :key="index" class="phoneContainer">
            <div class="pushMess"><b>通知时间：</b><span>{{list.createTime}}</span></div>
            <div class="pushMess"><b>通知类型：</b><span>{{list.noticeTypeDesc?list.noticeTypeDesc:'无'}}</span></div>
            <div class="pushMess"><b>通知结果：</b><span :style="{color:list.isSuccessDesc=='成功'?'#009A02':'red'}">{{list.isSuccessDesc=='成功'?"成功":"失败"}}</span></div>
            <div class="pushMess1">
              <div class="userName">通知对象：</div>
              <div class="userTel">{{list.userInfo}}</div>
            </div>
            <div class="pushMess" v-if="list.isSuccessDesc=='失败'"><b>失败原因：</b><span>{{list.errorMsg?list.errorMsg:'无'}}</span></div>            
          </div>
      </div>
      <div class="noneData" v-if="sendresult1.length==0">
          <div class="mess">==暂无数据==</div>
      </div>
   </div>
</div>
</template>

<script>
// var md5 = require("js-md5");
export default {
    //注册局部过滤器
   filters: {
      timefilters(val) {
         if (val == null || val == "") {
            return "暂无时间";
         } else {
            let d = new Date(val); //val 为表格内取到的后台时间
            let month =
               d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
            let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
            let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
            let times =
               d.getFullYear() +
               "-" +
               month +
               "-" +
               day +
               " " +
               hours +
               ":" +
               min +
               ":" +
               sec;
            return times;
         }
      }
   },
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      sendresult1:[],
      // loading: false,
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.pushquery();
    },
    pushquery(){//根据报警记录查询报警通知列表
     this.request.get("/front/alarm/notice/record/queryByAlarm?alarmId="+this.editData.id).then(res => {
         if (res.code == 200) {
          this.sendresult1 = res.data
          this.sendresult1.forEach(item => {
            if (item.notifyUserInfoDTOList && item.notifyUserInfoDTOList.length !== 0) {
              let user = []
              item.notifyUserInfoDTOList.forEach(ss => {
                let con = ss.nickName + '：' + ss.tel
                user.push(con)
              })
              item.userInfo = user.join('，')
              console.log(item);
            } else {
              item.userInfo = ''
            }
          })
           
          }else if(res.code==500){
            this.msg.warn(res.msg)
            this.sendresult1=[]
          }
        }).catch(error => {
          console.log(error)
        })
    },

  }
};
</script>

<style lang="scss" scoped>
.drawerWrap {
  .drawerBody {
    padding-top: 20px;
    .phoneContainer{
       padding:0 0 15px 15px;
       border-bottom: 1px dashed #ccc;
    }
    .pushMess {
      font-size: 14px;
      line-height: 30px;
      color: #525252;

      b {
        font-weight: 500;
      }
      
      span {
      }
    }
    .pushMess1 {
      display: flex;
      font-size: 14px;
      line-height: 30px;
      color: #525252;
      margin-bottom: 10px;
      .userTel {
        width: 385px;
        // overflow: hidden;
        word-wrap:break-word; 
        word-break:break-all; 
      }
      .userName {
        width: 80px;
        height: 20px;
      }
    }
    .noneData{
        margin-top: 20px;
        text-align: center;
       .mess {
          font-size: 14px;
          font-weight: 500;
          color: #409EFF;
       }
    }
  }
}
</style>
<style lang="scss">
.alarmDrawer {
  .drawerBody {
     .el-tabs{
        padding-left:20px;
     }
  }
}
</style>
